/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, max: NonNullable<unknown> }} Plan_Superset_SizeInputs */

const en_us2_plan_superset_size = /** @type {(inputs: Plan_Superset_SizeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A superset groups ${i?.min} to ${i?.max} different exercises.`)
};

const pt_br2_plan_superset_size = /** @type {(inputs: Plan_Superset_SizeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um superset junta de ${i?.min} a ${i?.max} exercícios diferentes.`)
};

const es_419_plan_superset_size = /** @type {(inputs: Plan_Superset_SizeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Una superserie agrupa de ${i?.min} a ${i?.max} ejercicios diferentes.`)
};

const pt_pt2_plan_superset_size = /** @type {(inputs: Plan_Superset_SizeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um superset junta de ${i?.min} a ${i?.max} exercícios diferentes.`)
};

const fr_fr2_plan_superset_size = /** @type {(inputs: Plan_Superset_SizeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un superset regroupe de ${i?.min} à ${i?.max} exercices différents.`)
};

const de_de2_plan_superset_size = /** @type {(inputs: Plan_Superset_SizeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ein Supersatz fasst ${i?.min} bis ${i?.max} verschiedene Übungen zusammen.`)
};

const it_it2_plan_superset_size = /** @type {(inputs: Plan_Superset_SizeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un superset raggruppa da ${i?.min} a ${i?.max} esercizi diversi.`)
};

/**
* | output |
* | --- |
* | "A superset groups {min} to {max} different exercises." |
*
* @param {Plan_Superset_SizeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_superset_size = /** @type {((inputs: Plan_Superset_SizeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Superset_SizeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_superset_size(inputs)
	if (locale === "es-419") return es_419_plan_superset_size(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_superset_size(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_superset_size(inputs)
	if (locale === "de-DE") return de_de2_plan_superset_size(inputs)
	if (locale === "it-IT") return it_it2_plan_superset_size(inputs)
	return en_us2_plan_superset_size(inputs)
});
export { plan_superset_size as "plan.superset_size" }